import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import { getServices } from "@/lib/api";
import SectionTitle from "@/components/SectionTitle";

export default function Services() {
  const [services, setServices] = useState([]);
  useEffect(() => { getServices().then(setServices).catch(() => {}); }, []);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20" data-testid="services-page">
      <SectionTitle
        eyebrow="Departments & Specialties"
        title="Whole-person care, delivered by specialists."
        description="From routine visits to complex surgeries — every department is built around one belief: patients heal faster when they feel heard."
      />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {services.map((s, i) => (
          <Link
            key={s.id}
            to={`/services/${s.slug}`}
            data-testid={`service-tile-${s.slug}`}
            className="group rounded-3xl overflow-hidden border border-brand-border bg-white hover:-translate-y-1 transition-transform fade-up"
            style={{ animationDelay: `${i * 60}ms` }}
          >
            <div className="aspect-[16/10] overflow-hidden">
              <img src={s.image} alt={s.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            </div>
            <div className="p-7">
              <div className="text-xs uppercase tracking-[0.2em] text-brand-sage mb-2">{s.short_description}</div>
              <h3 className="font-serif text-2xl text-brand-ink leading-tight">{s.name}</h3>
              <p className="text-brand-muted text-sm mt-3 leading-relaxed line-clamp-3">{s.description}</p>
              <div className="mt-5 flex items-center gap-2 text-brand-sage text-sm font-medium">
                View department <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
